import * as yup from 'yup';

/* eslint-disable import/prefer-default-export */

export const validationSchema = yup.object().shape({
  password: yup.string(),
  passwordConfirmation: yup.string(),
});
